if (!window.Eurus.loadedScript.has('product-features.js')) {
  window.Eurus.loadedScript.add('product-features.js');

  const setTooltipState = (trigger, isOpen) => {
    const tooltip = document.getElementById(trigger.getAttribute('aria-controls'));

    if (!tooltip) return;

    trigger.setAttribute('aria-expanded', isOpen);
    tooltip.setAttribute('aria-hidden', !isOpen);

    if (isOpen) {
      tooltip.removeAttribute('inert');
    } else {
      tooltip.setAttribute('inert', '');
    }
  };

  const closeOpenTooltips = (exceptTrigger = null) => {
    document.querySelectorAll('.feature-tooltip-trigger[aria-expanded="true"]').forEach((trigger) => {
      if (trigger !== exceptTrigger) setTooltipState(trigger, false);
    });
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.feature-tooltip-trigger');

    if (trigger) {
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      closeOpenTooltips(trigger);
      setTooltipState(trigger, !isOpen);
      return;
    }

    document.querySelectorAll('.feature-tooltip-trigger[aria-expanded="true"]').forEach((openTrigger) => {
      const featureItem = openTrigger.closest('.features-list-item');
      const featureHeader = featureItem?.querySelector('.feature-header');
      const tooltip = document.getElementById(openTrigger.getAttribute('aria-controls'));

      if (!featureHeader?.contains(event.target) && !tooltip?.contains(event.target)) {
        setTooltipState(openTrigger, false);
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeOpenTooltips();
  });
}
